import styled from '@emotion/styled';

import { screen } from '@/components/common/breakpoints';
import { RichHeading } from '@/components/common/Heading';
import { HeadingLevel } from '@/components/common/MarkUp';
import { PortableText } from '@/components/common/utils';

import type { SanityBlock, SanityKeyed } from 'sanity-codegen';

interface HeadingTextProps {
  columnHeading?: Array<SanityKeyed<SanityBlock>>;
  body: Array<SanityKeyed<SanityBlock>>;
}

const HeadingText = ({ columnHeading, body }: HeadingTextProps) => {
  return (
    <ColumnWrapper>
      {columnHeading && (
        <HeadingLevel>
          <RichHeading size="subheadline" heading={columnHeading} />
        </HeadingLevel>
      )}
      <PortableText value={body} />
    </ColumnWrapper>
  );
};

const ColumnWrapper = styled.div`
  padding-top: var(--spacing-300);
  &:first-of-type {
    padding-top: var(--spacing-small);
  }

  h3 {
    font-weight: var(--font-weight-bold);
    margin-bottom: var(--spacing-xxx-small);
  }

  p {
    color: var(--text-strong);
    margin-bottom: var(--spacing-xx-small);
  }

  ${screen.sm} {
    padding-top: 0;
    &:first-of-type {
      padding-top: 0;
    }
  }
`;

export { HeadingText };
